import type { IconSvgObject } from './types';

const GloveIcon: IconSvgObject = [
  ["path", { d: "M19.5 17L12 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.98437 9.42066V14L6.45747 11.9534C5.7136 10.9563 4.23891 10.9183 3.44521 11.8758C2.89412 12.5406 2.8503 13.4928 3.33799 14.2059L7.38871 20.129C7.76147 20.6741 8.37924 21 9.03957 21H17.3184C18.2905 21 19.1218 20.301 19.2887 19.3434L20.917 10C21.5659 6.0864 18.318 3 14.3713 3C10.8439 3 7.98437 5.87463 7.98437 9.42066Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default GloveIcon;
